import React, { useState } from "react";

// import icons
import BarsIcon from "../assets/img/bars.png";
import CloseIcon from "../assets/img/close.png";

// import navigation data
import { navigation } from "../data";

// import Link
import { Link } from "react-scroll";

const NavMobile = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="lg:hidden relative z-20">
      {/* menu icon */}
      <button
        onClick={() => setIsOpen(true)}
        className="cursor-pointer"
        aria-label="Open menu"
      >
        <img
          src={BarsIcon}
          alt="menu"
          className="w-6 h-6 pointer-events-none"
        />
      </button>
      {/* nav list */}
      <ul
        className={`${
          isOpen ? "right-0" : "-right-full"
        } bg-primary fixed top-0 w-full h-screen text-white transition-all flex flex-col justify-center items-center space-y-8 text-lg`}
      >
        {/* close icon */}
        <button
          className="absolute top-6 left-6 cursor-pointer"
          onClick={() => setIsOpen(false)}
          aria-label="Close menu"
        >
          <img
            src={CloseIcon}
            alt="close menu"
            className="w-6 h-6 pointer-events-none"
          />
        </button>
        {navigation.map((item, index) => {
          return (
            <li key={index}>
              <Link
                to={item.href}
                activeClass="active"
                spy={true}
                offset={-220}
                className="cursor-pointer hover:text-[#ec9f68] transition-colors"
              >
                {item.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default NavMobile;
